// Simple data exporters for CSV and XLSX
// CSV export has no dependencies. XLSX export uses the 'xlsx' package when available.

export function exportToCSV(filename, rows, { delimiter = ',', bom = true } = {}) {
  if (!Array.isArray(rows) || rows.length === 0) {
    const blob = new Blob([bom ? '\uFEFF' : '', ''], { type: 'text/csv;charset=utf-8;' });
    triggerDownload(blob, ensureExtension(filename, '.csv'));
    return;
  }
  const headers = Array.from(
    rows.reduce((set, row) => {
      Object.keys(row || {}).forEach((k) => set.add(k));
      return set;
    }, new Set())
  );
  const escape = (val) => {
    if (val == null) return '';
    const s = String(val).replace(/\r?\n|\r/g, ' ').trim();
    if (s.includes(delimiter) || s.includes('"')) {
      return '"' + s.replace(/"/g, '""') + '"';
    }
    return s;
  };
  const lines = [];
  lines.push(headers.map(escape).join(delimiter));
  for (const row of rows) {
    const line = headers.map((h) => escape(row[h]));
    lines.push(line.join(delimiter));
  }
  const content = (bom ? '\uFEFF' : '') + lines.join('\n');
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  triggerDownload(blob, ensureExtension(filename, '.csv'));
}

export async function exportToXLSX(filename, sheets) {
  // sheets: [{ name: string, data: Array<object> }]
  try {
    const XLSX = await import(/* webpackChunkName: "xlsx-chunk" */ 'xlsx');
    const wb = XLSX.utils.book_new();
    for (const sheet of sheets || []) {
      const ws = XLSX.utils.json_to_sheet(sheet.data || []);
      XLSX.utils.book_append_sheet(wb, ws, sheet.name?.slice(0, 31) || 'Sheet');
    }
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    triggerDownload(blob, ensureExtension(filename, '.xlsx'));
  } catch (e) {
    // Fallback to CSV for the first sheet
    if (sheets && sheets.length > 0) {
      exportToCSV(filename, sheets[0].data || []);
    } else {
      const blob = new Blob(['No data'], { type: 'text/plain;charset=utf-8;' });
      triggerDownload(blob, ensureExtension(filename, '.txt'));
    }
  }
}

export function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function ensureExtension(filename, ext) {
  if (!filename) return 'export' + ext;
  if (filename.toLowerCase().endsWith(ext)) return filename;
  return filename + ext;
}
